var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "box" } },
    [
      _c(
        "a-card",
        {
          staticStyle: {
            "box-sizing": "border-box",
            "border-radius": "0 !important",
          },
        },
        [
          _c("Header"),
          _c("div", { staticStyle: { height: "80px" } }),
          _c(
            "div",
            { staticClass: "paydemo", staticStyle: { width: "100%" } },
            [
              _c("div", { staticClass: "paydemo_title" }, [
                _vm._v("插入CA证书"),
                _c("i", [_vm._v("(如图下图所示证书)")]),
                _vm._v("，点击开始检测"),
              ]),
              _c("img", {
                staticClass: "jianceimg",
                attrs: { src: _vm.jianceimg },
              }),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "row",
                    "justify-content": "center",
                    "padding-top": "80px",
                  },
                },
                [
                  _c(
                    "a-button",
                    {
                      staticStyle: {
                        "font-weight": "bold",
                        width: "200px",
                        "background-color": "red",
                        height: "40px",
                        "font-size": "15px",
                        border: "0",
                        background: "#122B88",
                        "border-color": "#122B88",
                      },
                      attrs: { type: "primary" },
                      on: { click: _vm.handleSubmit },
                    },
                    [_vm._v(" 点击开始检测 ")]
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "row",
                    "justify-content": "center",
                    color: "#132b75",
                    "line-height": "50px",
                    cursor: "pointer",
                  },
                  on: { click: _vm.homepay },
                },
                [_vm._v("返回首页")]
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "检测中...",
            visible: _vm.dialogVisible,
            width: "50%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { position: "relative" } },
            [
              _c(
                "el-table",
                {
                  key: _vm.two,
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.messagestwo,
                    border: "",
                    fit: "",
                    "highlight-current-row": "",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "检测结果", align: "left" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [_c("span", [_vm._v(_vm._s(row.title))])]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm.tianshu < 30
                ? _c(
                    "b",
                    {
                      staticStyle: {
                        "line-height": "20px",
                        "font-size": "10px",
                        color: "red",
                        "padding-left": "10px",
                      },
                    },
                    [_vm._v("此服务少于30天！请尽快续费此服务！")]
                  )
                : _vm._e(),
              _vm.buttonstate
                ? _c(
                    "el-button",
                    {
                      staticClass: "paydemo-button",
                      attrs: { shape: "round", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.fixinadvance()
                        },
                      },
                    },
                    [_vm._v("点此订购")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
      _c("Footer"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }